import React from 'react';
import { useHistory } from 'react-router-dom';
import Table from '../components/Table/Table';
import { useDispatch } from 'react-redux';
import usePpis from '../features/PpiContainer/hooks/usePpis';
import useViewVisited from '../features/app/hooks/useViewVisted';
import {
  EnrichmentData as PpiEnrichmentData,
  States as PpiStates
} from '../features/PpiContainer/constants';
import { ppiPublishedRoute } from '../routes';
import ProgressFullscreen from '../components/common/ProgressFullscreen';
import DataTypes from '../components/Table/dataTypes';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';
import useAlert from '../features/alertSystem/hooks/useAlert';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import { deletePpi } from 'features/PpiContainer/actions';

function getEnrichmentData(rowData) {
  const enrichmentDataName = PpiEnrichmentData.PUBLISHED;
  return rowData[enrichmentDataName];
}

const formatItemCode = itemCode => {
  return `${itemCode.substring(0, 3)} ${itemCode.substring(
    3,
    7
  )} ${itemCode.substring(7, itemCode.length)}`;
};

const UnpublishColumns = {
  IfoodId: {
    name: 'ifoodID',
    label: 'IFood Id',
    calculateCellValue: rowData => {
      return formatItemCode(rowData.itemCode);
    },
    width: 175,
    grow: 0,
    shrink: 0
  },
  PresentationName: {
    name: 'presentationName',
    label: 'Product Name',
    calculateCellValue: (rowData, { language }) => {
      const { info } = getEnrichmentData(rowData);
      return info[language].presentationName;
    }
  },
  ActualUnpublishedDate: {
    name: 'actualUnpublishedDate',
    dataField: 'actualUnpublishedDate',
    dataType: DataTypes.Date,
    label: 'Unpublished Date',
    calculateCellValue: rowData => {
      return getEnrichmentData(rowData).actualUnPublishedDate;
    },
    width: 150,
    grow: 0,
    shrink: 0,
    path: 'root'
  },
  UnpublishedBy: {
    name: 'unpublishedBy',
    label: 'Unpublished By',
    calculateCellValue: rowData => {
      return getEnrichmentData(rowData).unPublishBy;
    },
    width: 250,
    grow: 0
  }
};

const UnpublishedIngredientListView = () => {
  const history = useHistory();
  const [isFetchingPpis, ppis] = usePpis(PpiStates.UNPUBLISHED);
  const isFetching = isFetchingPpis;
  const dispatch = useDispatch();
  const { isViewVisited } = useViewVisited(
    View.UnpublishedPpi.name,
    isFetching
  );
  const isFetched = isViewVisited ? true : !isFetching;
  const [openAlert, closeAlert] = useAlert();

  if (isFetching) {
    return <ProgressFullscreen />;
  }

  const openInstruction = ({ id }) => {
    history.push(ppiPublishedRoute(id));
  };

  function deleteActionHandler(data, callback) {
    if (data.length > 0) {
      const getPayload = data && data.map(i => i.id);

      openAlert({
        title: <FormattedMessage id="notify.UnpublishedDeleteActionLabel" />,
        content: <FormattedMessage id="notify.UnpublishedDeleteHelperLabel" />,
        actions: {
          right: [
            <Button
              key="saveAndLeave"
              onClick={() => {
                closeAlert();
              }}
              color="primary"
            >
              <FormattedMessage id="notify.PpsiMultipleLanguageAlertCancel" />
            </Button>,
            <Button
              key="stay"
              onClick={() => {
                closeAlert();
                callback();
                dispatch(deletePpi(getPayload));
              }}
              color="primary"
            >
              <FormattedMessage id="notify.UnpublishedDeleteSuccessLabel" />
            </Button>
          ]
        }
      });
    }
  }

  const deleteHandler = [{ label: 'Delete', onClick: deleteActionHandler }];

  View.UnpublishedPpi.visit();

  return (
    <PaperContainer showProgress={!isFetched}>
      <Table
        title="unpublishList.unpublishPpiTableHeader"
        data={ppis}
        columns={[
          UnpublishColumns.IfoodId,
          UnpublishColumns.PresentationName,
          UnpublishColumns.ActualUnpublishedDate,
          UnpublishColumns.UnpublishedBy
        ]}
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'code', direction: 'asc' }]}
        selectable
        onRowClick={openInstruction}
        actions={deleteHandler}
      />
    </PaperContainer>
  );
};

export default UnpublishedIngredientListView;
